/* eslint-disable max-len */
import React from 'react'
import TopHeader from '../TopHeader'
export default function Emptyscreenwithouttitle({FirstPTag,SecondePTag,title,vitalHeight,customHeight}) {
    return (
        <>
            <div className={`bg-white rounded-lg py-3 px-6 ${vitalHeight ? 'h-[calc(100vh-378px)]' : customHeight ?'h-[calc(100vh-290px)]':'h-customh7'} flex flex-col justify-center items-center`}>
                <img src="/images/emptyscreen_img.png" alt="emptyscreen" className="mx-auto"/>
                <p id= "empty_screen" className="text-center text-xl font-normsl text-[#000]">{FirstPTag} <br />{SecondePTag}</p>
            </div>
           
        </>

       
    )
}
